import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { JournalPageComponent } from './pages/journal-page/journal-page.component';
import { InvoicesRouteNames } from '../../route-names';
import { InvoicesJournalComponent } from './pages/invoices-journal/invoices-journal.component';
import { SpecificationsJournalComponent } from './pages/specifications-journal/specifications-journal.component';
import { SpecificationState } from './pages/specification/store/specification.state';
import { AccountingInvoicesJournalComponent } from './pages/accounting-invoices-journal/accounting-invoices-journal.component';

export const SPECIFICATION_ROUTE: Route = {
  path: InvoicesRouteNames.SPECIFICATION.concat('/:id'),
  loadComponent: () =>
    import('./pages/specification/specification.component').then(
      c => c.SpecificationComponent,
    ),
  providers: [provideStates([SpecificationState])],
};

export const INVOICES_JOURNAL_ROUTES: Route[] = [
  {
    path: '',
    component: JournalPageComponent,
    children: [
      {
        path: '',
        redirectTo: InvoicesRouteNames.SPECIFICATION,
        pathMatch: 'full',
      },
      {
        title: 'Спецификации',
        path: InvoicesRouteNames.SPECIFICATION,
        component: SpecificationsJournalComponent,
      },
      {
        title: 'Инвойсы',
        path: InvoicesRouteNames.PARSED_INVOICE,
        component: InvoicesJournalComponent,
      },
      {
        title: 'Инвойсы (бухгалтерия)',
        path: InvoicesRouteNames.ACCOUNTING_INVOICE,
        component: AccountingInvoicesJournalComponent,
      },
      {
        path: '**',
        redirectTo: InvoicesRouteNames.SPECIFICATION,
        pathMatch: 'full',
      },
    ],
  },
];
